export function setCurrentNetwork( networkId ) {
    
    let network = '';

    switch( networkId ) {
        case 1: network = 'NED';
            break;
        case 2: network = 'TCH';
            break;
        case 3: network = 'FDN';
            break;
        case 4: network = 'WD';
            break;
        case 5: network = 'ID';
            break;
        case 6: network = 'BT';
            break;
        default: network = 'NED';
    }

    return network;
}

export function getCurrentNetwork( network ) {

    let networkId = '';

    switch( network ) {
        case 'NED': networkId = 1;
            break;
        case 'TCH': networkId = 2;
            break;
        case 'FDN': networkId = 3;
            break;
        case 'WD': networkId = 4;
            break;
        case 'ID': networkId = 5;
            break;
        case 'BT': networkId = 6;
            break;
        default: networkId = 1;
    }

    return networkId;
}

export function setLoaderColor( network ) {

    let networkColor = '';

    switch( network ) {
        case 'NED': networkColor = '#4DAF7C';
            break;
        case 'TCH': networkColor = '#E5A638';
            break;
        case 'FDN': networkColor = '#C20043';
            break;
        case 'WD': networkColor = '#785e70';
            break;
        case 'ID': networkColor = '#000';
            break;
        default: networkColor = '#4DAF7C';
    }

    return networkColor;
}

export function setNetworkTitle( networkId ) {
    let network = '';

    switch( networkId ) {
        case 'NED': network = 'Non-Executive Directors';
            break;
        case 'TCH': network = 'The Consultant Hub';
            break;
        case'FDN': network = 'Finance Director Network';
            break;
        case 'WD': network = 'Women Directors';
            break;
        case 'ID': network = 'Investor Director';
            break;
        case 'BT': network = 'Business Transformation';
            break;
        default: network = 'Non-Executive Directors';
    }

    return network;
}

export function setSearchTitle( network ) {

    switch( network ) {
        case 'NED': return 'Non-Executive';
        case 'TCH': return 'Consultancy';
        case 'FDN': return 'Finance';
        case 'WD': return 'Women';
        case 'ID': return 'Investor';
        default: return 'Non-Executive';
    }

}

export function getNetworkSiteName( networkId ) {
	let network = '';

	switch( networkId ) {
		case 'NED': network = 'NonExecutiveDirectors.com';
			break;
		case 'TCH': network = 'TheConsultantHub.com';
			break;
		case'FDN': network = 'FinanceDirectorNetwork.com';
			break;
		case 'WD': network = 'WomenDirectors.com';
			break;
		case 'ID': network = 'InvestorDirector.com';
			break;
		case 'BT': network = 'BusinessTransformation.COM';
			break;
		default: network = 'NonExecutiveDirectors.com';
	}

	return network;
}

/*export function getNetworkPagePermissions(type) {

    const permissions = JSON.parse( localStorage.getItem( 'permissions' ) );

    if( permissions ){
        const networkPermissions = permissions.filter( ( permission ) => {
            return networkId ? permission.network_id === networkId : permissions;
        } );

        return networkPermissions.filter( ( permission ) => {
            return permission.type === type;
        } )[ 0 ];
    }

    return false;

}*/

export function getProductPermissions( productType ) {
  const permissions = JSON.parse(localStorage.getItem('permissions'));
  if (permissions) {
    return permissions.filter((permission) => {
      return permission.type === productType;
    })[0];
  }
}



export function getWebinarPermissions(productId) {
  productId = parseInt(productId, 10);

  const permissions = JSON.parse(localStorage.getItem('permissions'));

  return permissions.filter((permission) => {
    return permission.product_id === productId;
  })[0];
}


export const getBTPermissions = () => {
    const permissions = JSON.parse(localStorage.getItem('permissions')).find( permission => permission.product_id === 17 || permission.product_id === 18 );
    return permissions ? permissions.execute : false;
};

export function getForumProduct( networkId, type ) {

    const permissions = JSON.parse( localStorage.getItem( 'permissions' ) );

    const networkPermissions = permissions.filter( ( permission ) => {
        return permission.network_id === networkId;
    } );

    return networkPermissions.filter( ( permission ) => {
        return permission.type === type;
    } )[ 0 ];
}


export function setBannerImages() {
  return [
    {
      "image": "/images/icon_membership-benefits-month.png",
      "content": "Hundreds of new non-exec and chair roles every month"
    },
    {
      "image": "/images/icon_membership-benefits-money.png",
      "content": "More paid opportunities than any other site"
    },
    {
      "image": "/images/icon_membership-benefits-jobs.png",
      "content": "Exclusive jobs you won’t find anywhere else"
    },
    {"image": "/images/icon_membership-benefits-global.png", "content": "Global sector coverage"},
    {
      "image": "/images/icon_membership-benefits-fees.png",
      "content": "No headhunter fees = more remuneration for you"
    }
  ];
}

// export function setBannerImages( networkId ) {
//     switch( networkId ) {
//         case 1: return [
//             { "image": "/images/icon_membership-benefits-month.png", "content": "Hundreds of new non-exec and chair roles every month" },
//             { "image": "/images/icon_membership-benefits-money.png", "content": "More paid opportunities than any other site" },
//             { "image": "/images/icon_membership-benefits-jobs.png", "content": "Exclusive jobs you won’t find anywhere else" },
//             { "image": "/images/icon_membership-benefits-global.png", "content": "Global sector coverage" },
//             { "image": "/images/icon_membership-benefits-fees.png", "content": "No headhunter fees = more remuneration for you" }
//         ];
//         case 2: return [
//             { "image": "/images/icon_membership-benefits-month.png", "content": "Thousands of new opportunities every month" },
//             { "image": "/images/icon_membership-benefits-jobs.png", "content": "Everything in one place, don't waste time searching numerous sites" },
//             { "image": "/images/icon_membership-benefits-flexible.png", "content": "Immediate start dates available" },
//             { "image": "/images/icon_membership-benefits-uk.png", "content": "Interim and permanent contracts across all sectors, UK-wide" },
//             { "image": "/images/icon_membership-benefits-fees.png", "content": "No headhunter fees = more remuneration for you" }
//         ];
//         case 3: return [
//             { "image": "/images/icon_membership-benefits-month.png", "content": "Top CFO and FD roles every week" },
//             { "image": "/images/icon_membership-benefits-jobs.png", "content": "Exclusive jobs you won’t find anywhere else" },
//             { "image": "/images/icon_membership-benefits-employers.png", "content": "From small start-ups to FTSE 100 companies, we have the role that’s right for you" },
//             { "image": "/images/icon_membership-benefits-uk.png", "content": "Interim and permanent positions across all sectors, UK-wide" },
//             { "image": "/images/icon_membership-benefits-fees.png", "content": "No headhunter fees = more remuneration for you" }
//         ];
//         case 4: return [
//             { "image": "/images/icon_membership-benefits-month.png", "content": "Hundreds of great new director roles every month" },
//             { "image": "/images/icon_membership-benefits-jobs.png", "content": "Exclusive jobs you won’t find anywhere else" },
//             { "image": "/images/icon_membership-benefits-global.png", "content": "Global sector coverage" },
//             { "image": "/images/icon_membership-benefits-money.png", "content": "Excellent salaries" },
//             { "image": "/images/icon_membership-benefits-fees.png", "content": "No headhunter fees = more remuneration for you" }
//         ];
//         case 5: return [
//             { "image": "/images/icon_membership-benefits-month.png", "content": "Fantastic investment opportunities every week" },
//             { "image": "/images/icon_membership-benefits-jobs.png", "content": "Exclusive investments you won’t find anywhere else" },
//             { "image": "/images/icon_membership-benefits-content.png", "content": "Takes the hassle out of finding investments" },
//             { "image": "/images/icon_membership-benefits-introduction.png", "content": "Connect directly with business owners - no middlemen" },
//             { "image": "/images/icon_membership-benefits-fees.png", "content": "Zero commission or finder’s fees" }
//         ];
//       default: return null;
//     }
// }

export function setBannerContent() {
  return {
    "heading": "To find your perfect non-executive director role, you need to have the right connections.",
    "sub_heading": "That’s where In Touch Networks comes in.",
    "paragraph_1": "We are the specialists at bringing top directors and employers together. Employers can approach paying members and list roles for no cost, which allows us to attract the best off-market opportunities for you – and without recruitment fees cutting into your remuneration.",
    "paragraph_2": "Premium, Gold and Platinum members gain access to hundreds of jobs and exclusive opportunities every month. And it works! We’re used by board members from some of the biggest companies around the globe.",
    "paragraph_3": "Don’t just take our word for it - see what our members have to say about the fantastic roles they’ve secured with us."
  };
};

// export function setBannerContent( network ) {
//     switch( network ) {
//         case 1: return {
//             "heading": "To find your perfect non-executive director role, you need to have the right connections.",
//             "sub_heading": "That’s where In Touch Networks comes in.",
//             "paragraph_1": "We are the specialists at bringing top directors and employers together. Employers can approach paying members and list roles for no cost, which allows us to attract the best off-market opportunities for you – and without recruitment fees cutting into your remuneration.",
//             "paragraph_2": "Premium, Gold and Platinum members gain access to hundreds of jobs and exclusive opportunities every month. And it works! We’re used by board members from some of the biggest companies around the globe.",
//             "paragraph_3": "Don’t just take our word for it - see what our members have to say about the fantastic roles they’ve secured with us.",
//         };
//         case 2: return {
//             "heading": "Whether you’re looking for interim or permanent work, whether you’re an established consultant or you’re just beginning your career, In Touch Networks has the contracts to meet your needs.",
//             "sub_heading": "We have over 10 years of experience bringing consultants and employers together.",
//             "paragraph_1": "Employers can approach paying members and list roles for no cost, which allows us to attract the best off-market opportunities for you – and without recruitment fees cutting into your remuneration.",
//             "paragraph_2": "Members gain access to thousands of jobs and exclusive opportunities every month. And it works! 40,000 top professionals are already using the network to establish and enhance their portfolio careers.",
//             "paragraph_3": "Don’t just take our word for it - see what our members have to say about the fantastic roles they’ve secured with us.",
//         };
//         case 3: return {
//             "heading": "Looking to take the next step in your finance career? In Touch Networks offers access to the UK’s most sought-after finance roles.",
//             "sub_heading": "We are experts in bringing top professionals and employers together.",
//             "paragraph_1": "Employers can approach paying members and list roles for no cost, which allows us to attract the best off-market opportunities for you – and without recruitment fees cutting into your remuneration.",
//             "paragraph_2": "Premium, Gold and Platinum members gain access to thousands of jobs and exclusive opportunities every month. And it works! 40,000 top professionals are already using the network to establish and enhance their portfolio careers.",
//             "paragraph_3": "Don’t just take our word for it - see what our members have to say about the fantastic roles they’ve secured with us.",
//         };
//         case 4: return {
//             "heading": "In Touch Networks makes it as easy as possible for you to find your dream job.",
//             "sub_heading": "We are the specialists at bringing top directors and employers together.",
//             "paragraph_1": "Employers can approach paying members and list roles for no cost, which allows us to attract the best off-market opportunities for you – and without recruitment fees cutting into your remuneration.",
//             "paragraph_2": "Premium, Gold and Platinum members gain access to hundreds of jobs and exclusive opportunities every month. And it works! We’re used by board members from some of the biggest companies around the globe.",
//             "paragraph_3": "Don’t just take our word for it - see what our members have to say about the fantastic roles they’ve secured with us.",
//         };
//         case 5: return {
//             "heading": "Looking for that next great investment opportunity?",
//             "sub_heading": "We specialise in bringing together elite business leaders with companies who need their help.",
//             "paragraph_1": "Businesses seeking investment can approach paying members and list opportunities for no cost, which allows us to attract the best off-market investments for you – and without commission or finder’s fees getting in the way.",
//             "paragraph_2": "Premium, Gold and Platinum members gain full access to the investments board, the perfect place to build and enhance your portfolio.",
//             "paragraph_3": "Don’t just take our word for it - see what our members have to say about finding success through the networks.",
//         };
//         default: return null;
//     }
// }

export function getSponsorshipType( screenWidth ) {

    screenWidth = parseInt( screenWidth, 10 );

    switch( true ) {
        case ( screenWidth <= 480 ): return 1; // 1 = Mobile
        case ( screenWidth > 480 && screenWidth < 768 ): return 2; // 2 = Tablet
        case ( screenWidth >= 768 ): return 3; // 3 = Desktop
        default: return 'desktop';
    }

}



// WEBPACK FOOTER //
// src/client/helpers/networkHelpers.js